import styles from "./styles.module.css";

export type LoadingProps = {
  show?: boolean;
};

function Loading({ show = true }: LoadingProps) {
  if (!show) return null;

  return (
    <div className={styles.loadingContainer}>
      <div className={styles.ldsFacebook}>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}

export { Loading };
